/**
 * Test IDs for QA automation.
 */
export const testIds = {
  ratingTablesListCreateRatingTable: "rating-tables-list-create-rating-table",
  ratingTablesListEdit: "rating-tables-list-edit",
  ratingTablesListDelete: "rating-tables-list-delete",
  ratingTablesListCopy: "rating-tables-list-copy",
} as const;
